import React from 'react';
import SVG from 'react-inlinesvg';

import CloseIcon from '../../../../assets/icons/DeleteDisabled2.svg';

import { Text, Divider } from '../..';

export default function Header({ title, closeCb }) {
  return (
    <div
      style={{
        width: '100%',
        height: 30,
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          boxSizing: 'border-box',
          padding: '10px',
        }}
      >
        <Text.h4>{title}</Text.h4>
        <SVG
          className="svg"
          src={CloseIcon}
          width={23}
          color="var(--color-gray-50)"
          cursor="pointer"
          onClick={closeCb}
        />
      </div>
      <Divider.Horizontal />
    </div>
  );
}
